import React from "react";

export default function FooterComponent() {
  return <div className="layout-footer"></div>;
}
